import React, {
  useEffect,
  useState,
} from "react";

import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

import {
  FaNewspaper,
} from "react-icons/fa";

const NewsPage = () => {
  const [news, setNews] =
    useState([]);

  const [open, setOpen] =
    useState(false);

  useEffect(() => {
    fetch(
      "https://stjosephweb.ilakshyaerp.in/api/news"
    )
      .then((res) =>
        res.json()
      )
      .then((data) =>
        setNews(
          Array.isArray(data)
            ? data
            : []
        )
      )
      .catch((err) =>
        console.log(
          "News fetch error:",
          err
        )
      );
  }, []);

  return (
    <>
      <Header
        toggleSidebar={() =>
          setOpen(true)
        }
      />

      <Sidebar
        isOpen={open}
        close={() =>
          setOpen(false)
        }
      />

      {/* HERO */}
      <section className="relative overflow-hidden bg-gradient-to-r from-[#072F5F] via-[#0B4F9C] to-[#072F5F] py-20 md:py-28">

        {/* DESIGN */}
        <div className="absolute inset-0 opacity-10">

          <div className="absolute top-0 left-0 w-72 h-72 bg-white rounded-full blur-3xl"></div>

          <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#D4A017] rounded-full blur-3xl"></div>

        </div>

        <div className="relative max-w-7xl mx-auto px-5 md:px-10 text-center">

          <div className="w-20 h-20 rounded-3xl bg-white/10 backdrop-blur-md flex items-center justify-center text-white text-3xl mx-auto shadow-2xl">

            <FaNewspaper />

          </div>

          <span className="inline-block mt-6 text-[#D4A017] uppercase tracking-[5px] text-sm font-bold">

            Latest Updates

          </span>

          <h1 className="text-4xl md:text-6xl font-extrabold text-white mt-5">

            SCHOOL NEWS

          </h1>

          <p className="text-gray-200 text-lg mt-6 max-w-3xl mx-auto leading-8">

            Stay updated with the latest
            activities, achievements and
            important happenings at
            Nav Jeevan Mission School.

          </p>

        </div>

      </section>

      {/* NEWS SECTION */}
      <section className="w-full bg-[#f7f9fc] py-16 md:py-24 overflow-x-hidden">

        <div className="max-w-7xl mx-auto px-5 md:px-10">

          {/* HEADING */}
          <div className="text-center mb-16">

            <span className="text-[#D4A017] uppercase tracking-[5px] text-sm font-bold">

              News & Updates

            </span>

            <h2 className="text-4xl md:text-5xl font-extrabold text-[#072F5F] mt-4">

              Latest School News

            </h2>

            <div className="w-24 h-1 bg-[#D4A017] rounded-full mx-auto mt-6"></div>

          </div>

          {/* NEWS GRID */}
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8">

            {news.length > 0 ? (
              news.map((n) => (
                <div
                  key={n.id}
                  className="group bg-white rounded-[30px] overflow-hidden shadow-lg border border-gray-100 hover:-translate-y-2 hover:shadow-2xl transition-all duration-500"
                >

                  {/* IMAGE */}
                  <div className="relative overflow-hidden">

                    <img
                      src={`https://stjosephweb.ilakshyaerp.in/uploads/news/${n.image}`}
                      alt="news"
                      className="w-full h-[260px] object-cover group-hover:scale-110 transition-all duration-700"
                    />

                    {/* OVERLAY */}
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent"></div>

                  </div>

                  {/* CONTENT */}
                  <div className="p-7">

                    <h3 className="text-2xl font-extrabold text-[#072F5F] leading-snug line-clamp-2">

                      {n.title}

                    </h3>

                    <div className="w-14 h-[3px] bg-[#D4A017] rounded-full mt-5 mb-5"></div>

                    <p className="text-gray-600 leading-8 text-[15px] line-clamp-5">

                      {n.description}

                    </p>

                  </div>

                </div>
              ))
            ) : (
              <div className="col-span-full">

                <div className="bg-white rounded-[30px] shadow-lg border border-gray-100 p-16 text-center">

                  <div className="w-20 h-20 rounded-full bg-[#0B4F9C]/10 text-[#0B4F9C] flex items-center justify-center text-3xl mx-auto mb-6">

                    <FaNewspaper />

                  </div>

                  <h3 className="text-3xl font-extrabold text-[#072F5F]">

                    No News Available

                  </h3>

                  <p className="text-gray-500 mt-4 text-lg">

                    Latest updates will appear here soon.

                  </p>

                </div>

              </div>
            )}

          </div>

        </div>

      </section>

      <Footer />
    </>
  );
};

export default NewsPage;